import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7uqvqdhwrg: FaireBrandEntity = {
  token: "b_7uqvqdhwrg",
  type: "brand",
  name: "Heavy Metal Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/da29c22c8ec3d93b7eb3cf0daab7edfd61ed0d9518ed56be3a4f2d4d6dedf321.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ac73dce5126583050202f0ff75d571c7123978db3c7574814d4835bb921366d8.png",
  logoUrl:
    "https://cdn.faire.com/fastly/da29c22c8ec3d93b7eb3cf0daab7edfd61ed0d9518ed56be3a4f2d4d6dedf321.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ac73dce5126583050202f0ff75d571c7123978db3c7574814d4835bb921366d8.png",
  location: "WILLIAMSTON, MI, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 5,
  isTopShop: true,
  isInsider: true,
  description:
    "Heavy Metal Jewelry (TM) is a family owned and operated business located in Williamston Michigan. Jody Ballor bought the company (formerly named Atocha Treasure Co) and moved it from Florida to Michigan in October 2020. The business office and warehouse are both located in Perry MI, a small town just outside of Lansing MI. \n\nHeavy Metal Jewelry (trademark) is a main supplier of high quality stainless steel jewelry to over 300 Harley Davidson Dealers, Leather Shops and Independent Vendors across the United States. The company’s products are also available directly to consumers through this website as well as eBay and Etsy.\n\nHeavy Metal Jewelry prides itself on providing high quality stainless steel biker jewelry and holds several patents on the bike chain bracelets, watches and earrings. Our products are all made with 316L Stainless Steel and are backed by a lifetime warranty.\n\nFeel free to reach out to any of us to chat or learn more about our story. We’d love to hear from you!",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:03.585Z",
    importedBy: "entity-db-cli",
  },
};
